/**
 * Generated With: pnpm x packages/api/tools/generate-shopify-rest-model.ts https://shopify.dev/api/admin/rest/reference/store-properties/shop
 * API Version: 2022-01
 */

import type { ModelTransitionState } from "@gadgetinc/conventions";
import { GadgetSystemDominionId } from "../../database/DominionLiterals";
import { doesVersionSupportShopifyAppPlatform } from "../../versioning/FrameworkVersions";
import { ApplyParamsRecordEffectSpecID, UpdateRecordEffectSpecID } from "../../database/behaviour/effects/GadgetEffectLiterals";
import { FieldType } from "../../type-system/FieldType";
import type { ShopifyApiVersion } from "./ShopifyApiVersion";
import { ShopifyDominion } from "./ShopifyDominion";
import type { ConnectionModelSpecVersion } from "./ShopifyMetadata";
import { buildConnectionSpec } from "./ShopifyMetadata";
import { shopifyCountryCodeEnumOptions, shopifyCurrencyCodeEnumOptions } from "./constants";
import {
  ShopifyAppCreditKey,
  ShopifyAppCreditToShopKey,
  ShopifyAppInstallationKey,
  ShopifyAppInstallationToShopKey,
  ShopifyAppPurchaseOneTimeKey,
  ShopifyAppPurchaseOneTimeToShopKey,
  ShopifyAppSubscriptionKey,
  ShopifyAppSubscriptionToShopKey,
  ShopifyAppUsageRecordKey,
  ShopifyAppUsageRecordToShopKey,
  ShopifyArticleKey,
  ShopifyArticleToShopKey,
  ShopifyAssetKey,
  ShopifyAssetToShopKey,
  ShopifyBalanceTransactionKey,
  ShopifyBalanceTransactionToShopKey,
  ShopifyBillingAddressKey,
  ShopifyBillingAddressToShopKey,
  ShopifyBlogKey,
  ShopifyBlogToShopKey,
  ShopifyBulkOperationKey,
  ShopifyBulkOperationToShopKey,
  ShopifyBusinessEntityKey,
  ShopifyBusinessEntityToShopKey,
  ShopifyCarrierServiceKey,
  ShopifyCarrierServiceToShopKey,
  ShopifyCartKey,
  ShopifyCartLineItemKey,
  ShopifyCartLineItemToShopKey,
  ShopifyCartToShopKey,
  ShopifyCatalogKey,
  ShopifyCatalogToShopKey,
  ShopifyCheckoutAppliedGiftCardKey,
  ShopifyCheckoutAppliedGiftCardToShopKey,
  ShopifyCheckoutKey,
  ShopifyCheckoutLineItemKey,
  ShopifyCheckoutLineItemToShopKey,
  ShopifyCheckoutShippingRateKey,
  ShopifyCheckoutShippingRateToShopKey,
  ShopifyCheckoutToShopKey,
  ShopifyCollectKey,
  ShopifyCollectToShopKey,
  ShopifyCollectionKey,
  ShopifyCollectionProductKey,
  ShopifyCollectionProductToShopKey,
  ShopifyCollectionToShopKey,
  ShopifyCommentKey,
  ShopifyCommentToShopKey,
  ShopifyCompanyAddressKey,
  ShopifyCompanyAddressToShopKey,
  ShopifyCompanyContactKey,
  ShopifyCompanyContactRoleAssignmentKey,
  ShopifyCompanyContactRoleAssignmentToShopKey,
  ShopifyCompanyContactRoleKey,
  ShopifyCompanyContactRoleToShopKey,
  ShopifyCompanyContactToShopKey,
  ShopifyCompanyKey,
  ShopifyCompanyLocationCatalogKey,
  ShopifyCompanyLocationCatalogToShopKey,
  ShopifyCompanyLocationKey,
  ShopifyCompanyLocationToShopKey,
  ShopifyCompanyToShopKey,
  ShopifyCountryKey,
  ShopifyCountryToShopKey,
  ShopifyCustomerAddressKey,
  ShopifyCustomerAddressToShopKey,
  ShopifyCustomerKey,
  ShopifyCustomerMergeableKey,
  ShopifyCustomerMergeableToShopKey,
  ShopifyCustomerPaymentMethodKey,
  ShopifyCustomerPaymentMethodToShopKey,
  ShopifyCustomerToShopKey,
  ShopifyDeliveryMethodKey,
  ShopifyDeliveryMethodToShopKey,
  ShopifyDiscountCodeKey,
  ShopifyDiscountCodeToShopKey,
  ShopifyDiscountCustomerBuysCollectionKey,
  ShopifyDiscountCustomerBuysCollectionToShopKey,
  ShopifyDiscountCustomerBuysProductKey,
  ShopifyDiscountCustomerBuysProductToShopKey,
  ShopifyDiscountCustomerBuysProductVariantKey,
  ShopifyDiscountCustomerBuysProductVariantToShopKey,
  ShopifyDiscountCustomerGetsCollectionKey,
  ShopifyDiscountCustomerGetsCollectionToShopKey,
  ShopifyDiscountCustomerGetsProductKey,
  ShopifyDiscountCustomerGetsProductToShopKey,
  ShopifyDiscountCustomerGetsProductVariantKey,
  ShopifyDiscountCustomerGetsProductVariantToShopKey,
  ShopifyDiscountKey,
  ShopifyDiscountRedeemCodeKey,
  ShopifyDiscountRedeemCodeToShopKey,
  ShopifyDiscountToShopKey,
  ShopifyDisputeEvidenceFulfillmentKey,
  ShopifyDisputeEvidenceFulfillmentToShopKey,
  ShopifyDisputeEvidenceKey,
  ShopifyDisputeEvidenceToShopKey,
  ShopifyDisputeFileUploadKey,
  ShopifyDisputeFileUploadToShopKey,
  ShopifyDisputeKey,
  ShopifyDisputeToShopKey,
  ShopifyDomainKey,
  ShopifyDomainToShopKey,
  ShopifyDraftOrderKey,
  ShopifyDraftOrderLineItemKey,
  ShopifyDraftOrderLineItemToShopKey,
  ShopifyDraftOrderPlatformDiscountAllocationKey,
  ShopifyDraftOrderPlatformDiscountAllocationToShopKey,
  ShopifyDraftOrderPlatformDiscountKey,
  ShopifyDraftOrderPlatformDiscountToShopKey,
  ShopifyDraftOrderToShopKey,
  ShopifyDutyKey,
  ShopifyDutyToShopKey,
  ShopifyEventKey,
  ShopifyEventToShopKey,
  ShopifyExchangeLineItemKey,
  ShopifyExchangeLineItemToShopKey,
  ShopifyFileKey,
  ShopifyFileToShopKey,
  ShopifyFulfillmentEventKey,
  ShopifyFulfillmentEventToShopKey,
  ShopifyFulfillmentHoldKey,
  ShopifyFulfillmentHoldToShopKey,
  ShopifyFulfillmentKey,
  ShopifyFulfillmentLineItemKey,
  ShopifyFulfillmentLineItemToShopKey,
  ShopifyFulfillmentOrderDestinationKey,
  ShopifyFulfillmentOrderDestinationToShopKey,
  ShopifyFulfillmentOrderKey,
  ShopifyFulfillmentOrderLineItemKey,
  ShopifyFulfillmentOrderLineItemToShopKey,
  ShopifyFulfillmentOrderMerchantRequestKey,
  ShopifyFulfillmentOrderMerchantRequestToShopKey,
  ShopifyFulfillmentOrderToShopKey,
  ShopifyFulfillmentServiceKey,
  ShopifyFulfillmentServiceToShopKey,
  ShopifyFulfillmentToShopKey,
  ShopifyGdprRequestKey,
  ShopifyGdprRequestToShopKey,
  ShopifyGiftCardKey,
  ShopifyGiftCardToShopKey,
  ShopifyInventoryItemKey,
  ShopifyInventoryItemToShopKey,
  ShopifyInventoryLevelKey,
  ShopifyInventoryLevelToShopKey,
  ShopifyInventoryQuantityKey,
  ShopifyInventoryQuantityToShopKey,
  ShopifyLocationKey,
  ShopifyLocationToShopKey,
  ShopifyMarketCatalogKey,
  ShopifyMarketCatalogToShopKey,
  ShopifyMarketKey,
  ShopifyMarketRegionKey,
  ShopifyMarketRegionToShopKey,
  ShopifyMarketToShopKey,
  ShopifyMarketWebPresenceKey,
  ShopifyMarketWebPresenceToShopKey,
  ShopifyOrderAdjustmentKey,
  ShopifyOrderAdjustmentToShopKey,
  ShopifyOrderKey,
  ShopifyOrderLineItemKey,
  ShopifyOrderLineItemToShopKey,
  ShopifyOrderRiskKey,
  ShopifyOrderRiskToShopKey,
  ShopifyOrderToShopKey,
  ShopifyOrderTransactionKey,
  ShopifyOrderTransactionToShopKey,
  ShopifyPageKey,
  ShopifyPageToShopKey,
  ShopifyPaymentScheduleKey,
  ShopifyPaymentScheduleToShopKey,
  ShopifyPaymentTermsKey,
  ShopifyPaymentTermsToShopKey,
  ShopifyPaymentsAccountKey,
  ShopifyPaymentsAccountToShopKey,
  ShopifyPayoutKey,
  ShopifyPayoutToShopKey,
  ShopifyPriceListKey,
  ShopifyPriceListPriceKey,
  ShopifyPriceListPriceToShopKey,
  ShopifyPriceListToShopKey,
  ShopifyPriceRuleKey,
  ShopifyPriceRuleToShopKey,
  ShopifyProductImageKey,
  ShopifyProductImageToShopKey,
  ShopifyProductKey,
  ShopifyProductMediaKey,
  ShopifyProductMediaToShopKey,
  ShopifyProductOptionKey,
  ShopifyProductOptionToShopKey,
  ShopifyProductToShopKey,
  ShopifyProductVariantKey,
  ShopifyProductVariantMediaKey,
  ShopifyProductVariantMediaToShopKey,
  ShopifyProductVariantToShopKey,
  ShopifyProvinceKey,
  ShopifyProvinceToShopKey,
  ShopifyQuantityPriceBreakKey,
  ShopifyQuantityPriceBreakToShopKey,
  ShopifyRedirectKey,
  ShopifyRedirectToShopKey,
  ShopifyRefundDutyKey,
  ShopifyRefundDutyToShopKey,
  ShopifyRefundKey,
  ShopifyRefundLineItemKey,
  ShopifyRefundLineItemToShopKey,
  ShopifyRefundToShopKey,
  ShopifyReturnKey,
  ShopifyReturnLineItemKey,
  ShopifyReturnLineItemToShopKey,
  ShopifyReturnReasonDefinitionKey,
  ShopifyRequestedOrderEditKey,
  ShopifyRequestedOrderEditToShopKey,
  ShopifyShopToRequestedOrderEditsKey,
  ShopifyRequestedOrderEditLineItemKey,
  ShopifyRequestedOrderEditLineItemToShopKey,
  ShopifyShopToRequestedOrderEditLineItemsKey,
  ShopifyReturnPolicyProfileKey,
  ShopifyReturnPolicyProfileToShopKey,
  ShopifyShopToReturnPolicyProfilesKey,
  ShopifyReturnReasonDefinitionToShopKey,
  ShopifyReturnShippingFeeKey,
  ShopifyReturnShippingFeeToShopKey,
  ShopifyReturnToShopKey,
  ShopifyReverseDeliveryKey,
  ShopifyReverseDeliveryLineItemKey,
  ShopifyReverseDeliveryLineItemToShopKey,
  ShopifyReverseDeliveryToShopKey,
  ShopifyReverseFulfillmentOrderDispositionKey,
  ShopifyReverseFulfillmentOrderDispositionToShopKey,
  ShopifyReverseFulfillmentOrderKey,
  ShopifyReverseFulfillmentOrderLineItemKey,
  ShopifyReverseFulfillmentOrderLineItemToShopKey,
  ShopifyReverseFulfillmentOrderToShopKey,
  ShopifyScriptTagKey,
  ShopifyScriptTagToShopKey,
  ShopifySegmentKey,
  ShopifySegmentToShopKey,
  ShopifySellingPlanGroupKey,
  ShopifySellingPlanGroupProductKey,
  ShopifySellingPlanGroupProductToShopKey,
  ShopifySellingPlanGroupProductVariantKey,
  ShopifySellingPlanGroupProductVariantToShopKey,
  ShopifySellingPlanGroupToShopKey,
  ShopifySellingPlanKey,
  ShopifySellingPlanToShopKey,
  ShopifyShippingAddressKey,
  ShopifyShippingAddressToShopKey,
  ShopifyShippingLineKey,
  ShopifyShippingLineToShopKey,
  ShopifyShopInstallKey,
  ShopifyShopKey,
  ShopifyShopReinstallKey,
  ShopifyShopToAppCreditsKey,
  ShopifyShopToAppInstallationsKey,
  ShopifyShopToAppPurchaseOneTimesKey,
  ShopifyShopToAppSubscriptionsKey,
  ShopifyShopToAppUsageRecordsKey,
  ShopifyShopToArticlesKey,
  ShopifyShopToAssetsKey,
  ShopifyShopToBalanceTransactionsKey,
  ShopifyShopToBillingAddressesKey,
  ShopifyShopToBlogsKey,
  ShopifyShopToBulkOperationsKey,
  ShopifyShopToBusinessEntitiesKey,
  ShopifyShopToCarrierServicesKey,
  ShopifyShopToCartLineItemsKey,
  ShopifyShopToCartsKey,
  ShopifyShopToCatalogsKey,
  ShopifyShopToCheckoutAppliedGiftCardsKey,
  ShopifyShopToCheckoutLineItemsKey,
  ShopifyShopToCheckoutShippingRatesKey,
  ShopifyShopToCheckoutsKey,
  ShopifyShopToCollectionProductsKey,
  ShopifyShopToCollectionsKey,
  ShopifyShopToCollectsKey,
  ShopifyShopToCommentsKey,
  ShopifyShopToCompaniesKey,
  ShopifyShopToCompanyAddressesKey,
  ShopifyShopToCompanyContactRoleAssignmentsKey,
  ShopifyShopToCompanyContactRolesKey,
  ShopifyShopToCompanyContactsKey,
  ShopifyShopToCompanyLocationCatalogsKey,
  ShopifyShopToCompanyLocationsKey,
  ShopifyShopToCountriesKey,
  ShopifyShopToCustomerAddressesKey,
  ShopifyShopToCustomerMergeablesKey,
  ShopifyShopToCustomerPaymentMethodsKey,
  ShopifyShopToCustomersKey,
  ShopifyShopToDeliveryMethodKey,
  ShopifyShopToDiscountCodesKey,
  ShopifyShopToDiscountCustomerBuysCollectionsKey,
  ShopifyShopToDiscountCustomerBuysProductVariantsKey,
  ShopifyShopToDiscountCustomerBuysProductsKey,
  ShopifyShopToDiscountCustomerGetsCollectionsKey,
  ShopifyShopToDiscountCustomerGetsProductVariantsKey,
  ShopifyShopToDiscountCustomerGetsProductsKey,
  ShopifyShopToDiscountRedeemCodesKey,
  ShopifyShopToDiscountsKey,
  ShopifyShopToDisputeEvidenceFulfillmentsKey,
  ShopifyShopToDisputeEvidencesKey,
  ShopifyShopToDisputeFileUploadsKey,
  ShopifyShopToDisputesKey,
  ShopifyShopToDomainsKey,
  ShopifyShopToDraftOrderLineItemsKey,
  ShopifyShopToDraftOrderPlatformDiscountAllocationsKey,
  ShopifyShopToDraftOrderPlatformDiscountsKey,
  ShopifyShopToDraftOrdersKey,
  ShopifyShopToDutiesKey,
  ShopifyShopToEventsKey,
  ShopifyShopToExchangeLineItemsKey,
  ShopifyShopToFilesKey,
  ShopifyShopToFulfillmentEventsKey,
  ShopifyShopToFulfillmentHoldKey,
  ShopifyShopToFulfillmentLineItemsKey,
  ShopifyShopToFulfillmentOrderDestinationKey,
  ShopifyShopToFulfillmentOrderLineItemsKey,
  ShopifyShopToFulfillmentOrderMerchantRequestKey,
  ShopifyShopToFulfillmentOrdersKey,
  ShopifyShopToFulfillmentServicesKey,
  ShopifyShopToFulfillmentsKey,
  ShopifyShopToGDPRRequestsKey,
  ShopifyShopToGiftCardsKey,
  ShopifyShopToInventoryItemsKey,
  ShopifyShopToInventoryLevelsKey,
  ShopifyShopToInventoryQuantityKey,
  ShopifyShopToLocationsKey,
  ShopifyShopToManualDiscountsKey,
  ShopifyShopToMarketCatalogsKey,
  ShopifyShopToMarketRegionsKey,
  ShopifyShopToMarketWebPresencesKey,
  ShopifyShopToMarketsKey,
  ShopifyShopToOrderAdjustmentsKey,
  ShopifyShopToOrderLineItemsKey,
  ShopifyShopToOrderRisksKey,
  ShopifyShopToOrderTransactionsKey,
  ShopifyShopToOrdersKey,
  ShopifyShopToPagesKey,
  ShopifyShopToPaymentSchedulesKey,
  ShopifyShopToPaymentTermsKey,
  ShopifyShopToPaymentsAccountKey,
  ShopifyShopToPayoutsKey,
  ShopifyShopToPriceListPricesKey,
  ShopifyShopToPriceListsKey,
  ShopifyShopToPriceRulesKey,
  ShopifyShopToPrimaryLocationKey,
  ShopifyShopToProductImagesKey,
  ShopifyShopToProductMediaKey,
  ShopifyShopToProductOptionsKey,
  ShopifyShopToProductVariantMediaKey,
  ShopifyShopToProductVariantsKey,
  ShopifyShopToProductsKey,
  ShopifyShopToProvincesKey,
  ShopifyShopToQuantityPriceBreaksKey,
  ShopifyShopToRedirectsKey,
  ShopifyShopToRefundDutiesKey,
  ShopifyShopToRefundLineItemsKey,
  ShopifyShopToRefundsKey,
  ShopifyShopToReturnLineItemsKey,
  ShopifyShopToReturnReasonDefinitionsKey,
  ShopifyShopToReturnShippingFeesKey,
  ShopifyShopToReturnsKey,
  ShopifyShopToReverseDeliveriesKey,
  ShopifyShopToReverseDeliveryLineItemsKey,
  ShopifyShopToReverseFulfillmentOrderDispositionsKey,
  ShopifyShopToReverseFulfillmentOrderLineItemsKey,
  ShopifyShopToReverseFulfillmentOrdersKey,
  ShopifyShopToScriptTagsKey,
  ShopifyShopToSegmentsKey,
  ShopifyShopToSellingPlanGroupsKey,
  ShopifyShopToSellingPlanGroupsProductVariantsKey,
  ShopifyShopToSellingPlanGroupsProductsKey,
  ShopifyShopToSellingPlansKey,
  ShopifyShopToShippingAddressesKey,
  ShopifyShopToShippingLinesKey,
  ShopifyShopToStoreCreditAccountsKey,
  ShopifyShopToSubscriptionBillingAttemptsKey,
  ShopifyShopToSubscriptionContractsKey,
  ShopifyShopToSubscriptionLinesKey,
  ShopifyShopToSyncsKey,
  ShopifyShopToTenderTransactionsKey,
  ShopifyShopToThemesKey,
  ShopifyShopUninstallKey,
  ShopifyShopUpdateKey,
  ShopifyStoreCreditAccountKey,
  ShopifyStoreCreditAccountToShopKey,
  ShopifySubscriptionBillingAttemptKey,
  ShopifySubscriptionBillingAttemptToShopKey,
  ShopifySubscriptionContractKey,
  ShopifySubscriptionContractToShopKey,
  ShopifySubscriptionLineKey,
  ShopifySubscriptionLineToShopKey,
  ShopifySubscriptionManualDiscountKey,
  ShopifySubscriptionManualDiscountToShopKey,
  ShopifySyncKey,
  ShopifySyncToShopKey,
  ShopifyTenderTransactionKey,
  ShopifyTenderTransactionToShopKey,
  ShopifyThemeKey,
  ShopifyThemeToShopKey,
} from "./keys";

/**
 * The datastructure describing the webhooks registered for a shop that we store on the shop record itself
 * Is a bit lossy compared to ShopifyWebhookRegistrationMap, prefer using that one but this one is still stored on shop records in prod so we keep it around.
 **/
export type RegisteredWebhooks = Record<
  string,
  {
    namespaces: string[];
    private_namespaces: string[];
    filters?: { filter?: string; includeFields?: string[] }[];
  }
>;

// field keys
export const ShopifyShopGrantedScopesKey = "ModelField-DataModel-Shopify-Shop-granted_scopes";
export const ShopifyShopRegisteredWebhooksKey = "ModelField-DataModel-Shopify-Shop-registered_webhooks";
export const ShopifyShopMyshopifyDomainKey = "ModelField-DataModel-Shopify-Shop-myshopify_domain";
export const ShopifyShopAccessTokenKey = "ModelField-DataModel-Shopify-Shop-access_token";
export const ShopifyShopInstalledViaAPIKeyKey = "ModelField-DataModel-Shopify-Shop-installed_via_api_key";
export const ShopifyShopDisabledWebhooksKey = "ModelField-DataModel-Shopify-Shop-disabled_webhooks";
export const ShopifyShopSpecificRegistrationKey = "ModelField-DataModel-Shopify-Shop-shop_specific_registration";
export const ShopifyShopRefreshTokenKey = "ModelField-DataModel-Shopify-Shop-refresh_token";
export const ShopifyShopAccessTokenExpiresAtKey = "ModelField-DataModel-Shopify-Shop-access_token_expires_at";
export const ShopifyShopRefreshTokenExpiresAtKey = "ModelField-DataModel-Shopify-Shop-refresh_token_expires_at";

// shop state keys
export const ShopifyShopInstalledKey = "State-Shopify-Shop-Installed";
export const ShopifyShopUninstalledKey = "State-Shopify-Shop-Uninstalled";

export const shopifyShopTransitionState: ModelTransitionState = {
  install: {
    to: { created: "installed" },
  },
  create: {
    // `create` is a legacy name for `install` action
    to: { created: "installed" },
  },
  reinstall: {
    from: { created: "uninstalled" },
    to: { created: "installed" },
  },
  uninstall: {
    from: { created: "installed" },
    to: { created: "uninstalled" },
  },
};

const specs: ConnectionModelSpecVersion = {
  key: ShopifyShopKey,
  defaultSearchableApiIdentifiers: [
    "address1",
    "address2",
    "billingAddress",
    "city",
    "country",
    "countryCode",
    "countryName",
    "customerEmail",
    "description",
    "domain",
    "email",
    "myshopifyDomain",
    "name",
    "phone",
    "plan",
    "planDisplayName",
    "planName",
    "planPublicDisplayName",
    "province",
    "provinceCode",
    "shopOwner",
    "url",
    "zip",
  ],
  defaultFilterableApiIdentifiers: ["domain", "myshopifyDomain", "name", "plan", "planDisplayName", "planName", "planPublicDisplayName"],
  "2022-01": {
    name: "Shopify Shop",
    graphQLTypename: "Shop",
    hasMetafields: true,
    fields: [
      {
        name: "Address 1",
        fieldType: FieldType.String,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "address1" } },
      },
      {
        name: "Address 2",
        fieldType: FieldType.String,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "address2" } },
      },
      {
        name: "Checkout API Supported",
        fieldType: FieldType.Boolean,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "checkout_api_supported" } },
      },
      {
        name: "City",
        fieldType: FieldType.String,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "city" } },
      },
      {
        name: "Cookie Consent Level",
        fieldType: FieldType.String,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "cookie_consent_level" } },
      },
      {
        name: "Country",
        fieldType: FieldType.String,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "country" } },
      },
      {
        name: "Country Code",
        fieldType: FieldType.String,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "country_code" } },
      },
      {
        name: "Country Name",
        fieldType: FieldType.String,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "country_name" } },
      },
      {
        name: "County Taxes",
        fieldType: FieldType.JSON,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "county_taxes" } },
      },
      {
        name: "Currency",
        fieldType: FieldType.String,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "currency" } },
      },
      {
        name: "Customer Email",
        fieldType: FieldType.String,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "customer_email" } },
      },
      {
        name: "Domain",
        fieldType: FieldType.String,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "domain" } },
      },
      {
        name: "Eligible For Card Reader Giveaway",
        fieldType: FieldType.Boolean,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "eligible_for_card_reader_giveaway",
          },
        },
      },
      {
        name: "Eligible For Payments",
        fieldType: FieldType.Boolean,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "eligible_for_payments" } },
      },
      {
        name: "Email",
        fieldType: FieldType.String,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "email" } },
      },
      {
        name: "Enabled Presentment Currencies",
        fieldType: FieldType.JSON,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "enabled_presentment_currencies" } },
      },
      {
        name: "Finances",
        fieldType: FieldType.Boolean,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "finances" } },
      },
      {
        name: "Force SSL",
        fieldType: FieldType.Boolean,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "force_ssl" } },
      },
      {
        name: "Google Apps Domain",
        fieldType: FieldType.String,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "google_apps_domain" } },
      },
      {
        name: "Google Apps Login Enabled",
        fieldType: FieldType.Boolean,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "google_apps_login_enabled" } },
      },
      {
        name: "Has Discounts",
        fieldType: FieldType.Boolean,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "has_discounts" } },
      },
      {
        name: "Has Gift Cards",
        fieldType: FieldType.Boolean,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "has_gift_cards" } },
      },
      {
        name: "Has Storefront",
        fieldType: FieldType.Boolean,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "has_storefront" } },
      },
      {
        name: "Iana Timezone",
        fieldType: FieldType.String,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "iana_timezone" } },
      },
      {
        name: "ID",
        fieldType: FieldType.ID,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "id" } },
      },
      {
        name: "Latitude",
        fieldType: FieldType.Number,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "latitude" } },
      },
      {
        name: "Longitude",
        fieldType: FieldType.Number,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "longitude" } },
      },
      {
        name: "Money Format",
        fieldType: FieldType.String,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "money_format" } },
      },
      {
        name: "Money In Emails Format",
        fieldType: FieldType.String,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "money_in_emails_format" } },
      },
      {
        name: "Money With Currency Format",
        fieldType: FieldType.String,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "money_with_currency_format" } },
      },
      {
        name: "Money With Currency In Emails Format",
        fieldType: FieldType.String,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "money_with_currency_in_emails_format",
          },
        },
      },
      {
        name: "Multi Location Enabled",
        fieldType: FieldType.Boolean,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "multi_location_enabled" } },
      },
      {
        key: ShopifyShopMyshopifyDomainKey,
        name: "myshopify Domain",
        fieldType: FieldType.String,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "myshopify_domain" } },
      },
      {
        name: "Name",
        fieldType: FieldType.String,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "name" } },
      },
      {
        name: "Password Enabled",
        fieldType: FieldType.Boolean,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "password_enabled" } },
      },
      {
        name: "Phone",
        fieldType: FieldType.String,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "phone" } },
      },
      {
        name: "Plan Display Name",
        fieldType: FieldType.String,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "plan_display_name" } },
      },
      {
        name: "Plan Name",
        fieldType: FieldType.String,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "plan_name" } },
      },
      {
        name: "Pre Launch Enabled",
        fieldType: FieldType.Boolean,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "pre_launch_enabled" } },
      },
      {
        name: "Primary Locale",
        fieldType: FieldType.String,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "primary_locale" } },
      },
      {
        name: "Primary Location",
        fieldType: FieldType.BelongsTo,
        key: ShopifyShopToPrimaryLocationKey,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "primary_location_id" } },
        configuration: {
          relatedModelKey: ShopifyLocationKey,
        },
      },
      {
        name: "Province",
        fieldType: FieldType.String,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "province" } },
      },
      {
        name: "Province Code",
        fieldType: FieldType.String,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "province_code" } },
      },
      {
        name: "Requires Extra Payments Agreement",
        fieldType: FieldType.Boolean,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "requires_extra_payments_agreement",
          },
        },
      },
      {
        name: "Setup Required",
        fieldType: FieldType.Boolean,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "setup_required" } },
      },
      {
        name: "Shop Owner",
        fieldType: FieldType.String,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "shop_owner" } },
      },
      {
        name: "Shopify Created At",
        fieldType: FieldType.DateTime,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "created_at" } },
      },
      {
        name: "Shopify Updated At",
        fieldType: FieldType.DateTime,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "updated_at" } },
      },
      {
        name: "Source",
        fieldType: FieldType.String,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "source" } },
      },
      {
        name: "Tax Shipping",
        fieldType: FieldType.Boolean,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "tax_shipping" } },
      },
      {
        name: "Taxes Included",
        fieldType: FieldType.Boolean,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "taxes_included" } },
      },
      {
        name: "Timezone",
        fieldType: FieldType.String,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "timezone" } },
      },
      {
        name: "Weight Unit",
        fieldType: FieldType.String,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "weight_unit" } },
      },
      {
        name: "ZIP Code",
        fieldType: FieldType.String,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "zip" } },
      },

      // Ownership associations for all Shopify models
      {
        name: "App Installations",
        fieldType: FieldType.HasMany,
        key: ShopifyShopToAppInstallationsKey,
        configuration: {
          relatedModelKey: ShopifyAppInstallationKey,
          inverseFieldKey: ShopifyAppInstallationToShopKey,
        },
      },
      {
        name: "App Credits",
        fieldType: FieldType.HasMany,
        key: ShopifyShopToAppCreditsKey,
        configuration: {
          relatedModelKey: ShopifyAppCreditKey,
          inverseFieldKey: ShopifyAppCreditToShopKey,
        },
      },
      {
        name: "App Purchase One Times",
        fieldType: FieldType.HasMany,
        key: ShopifyShopToAppPurchaseOneTimesKey,
        configuration: {
          relatedModelKey: ShopifyAppPurchaseOneTimeKey,
          inverseFieldKey: ShopifyAppPurchaseOneTimeToShopKey,
        },
      },
      {
        name: "App Subscriptions",
        fieldType: FieldType.HasMany,
        key: ShopifyShopToAppSubscriptionsKey,
        configuration: {
          relatedModelKey: ShopifyAppSubscriptionKey,
          inverseFieldKey: ShopifyAppSubscriptionToShopKey,
        },
      },
      {
        name: "App Usage Records",
        fieldType: FieldType.HasMany,
        key: ShopifyShopToAppUsageRecordsKey,
        configuration: {
          relatedModelKey: ShopifyAppUsageRecordKey,
          inverseFieldKey: ShopifyAppUsageRecordToShopKey,
        },
      },
      {
        name: "Balance Transactions",
        fieldType: FieldType.HasMany,
        key: ShopifyShopToBalanceTransactionsKey,
        configuration: {
          relatedModelKey: ShopifyBalanceTransactionKey,
          inverseFieldKey: ShopifyBalanceTransactionToShopKey,
        },
      },
      {
        name: "Carts",
        fieldType: FieldType.HasMany,
        key: ShopifyShopToCartsKey,
        configuration: {
          relatedModelKey: ShopifyCartKey,
          inverseFieldKey: ShopifyCartToShopKey,
        },
      },
      {
        name: "Cart Line Items",
        fieldType: FieldType.HasMany,
        key: ShopifyShopToCartLineItemsKey,
        configuration: {
          relatedModelKey: ShopifyCartLineItemKey,
          inverseFieldKey: ShopifyCartLineItemToShopKey,
        },
      },
      {
        name: "Collects",
        fieldType: FieldType.HasMany,
        key: ShopifyShopToCollectsKey,
        configuration: {
          relatedModelKey: ShopifyCollectKey,
          inverseFieldKey: ShopifyCollectToShopKey,
        },
      },
      {
        name: "Collections",
        fieldType: FieldType.HasMany,
        key: ShopifyShopToCollectionsKey,
        configuration: {
          relatedModelKey: ShopifyCollectionKey,
          inverseFieldKey: ShopifyCollectionToShopKey,
        },
      },
      {
        name: "Customer Addresses",
        fieldType: FieldType.HasMany,
        key: ShopifyShopToCustomerAddressesKey,
        configuration: {
          relatedModelKey: ShopifyCustomerAddressKey,
          inverseFieldKey: ShopifyCustomerAddressToShopKey,
        },
      },
      {
        name: "Customer Mergeables",
        fieldType: FieldType.HasMany,
        key: ShopifyShopToCustomerMergeablesKey,
        configuration: {
          relatedModelKey: ShopifyCustomerMergeableKey,
          inverseFieldKey: ShopifyCustomerMergeableToShopKey,
        },
      },
      {
        name: "Customer Payment Methods",
        fieldType: FieldType.HasMany,
        key: ShopifyShopToCustomerPaymentMethodsKey,
        configuration: {
          relatedModelKey: ShopifyCustomerPaymentMethodKey,
          inverseFieldKey: ShopifyCustomerPaymentMethodToShopKey,
        },
      },
      {
        name: "Customers",
        fieldType: FieldType.HasMany,
        key: ShopifyShopToCustomersKey,
        configuration: {
          relatedModelKey: ShopifyCustomerKey,
          inverseFieldKey: ShopifyCustomerToShopKey,
        },
      },
      {
        name: "Discount Codes",
        fieldType: FieldType.HasMany,
        key: ShopifyShopToDiscountCodesKey,
        configuration: {
          relatedModelKey: ShopifyDiscountCodeKey,
          inverseFieldKey: ShopifyDiscountCodeToShopKey,
        },
      },
      {
        name: "Domains",
        fieldType: FieldType.HasMany,
        key: ShopifyShopToDomainsKey,
        configuration: {
          relatedModelKey: ShopifyDomainKey,
          inverseFieldKey: ShopifyDomainToShopKey,
        },
      },
      {
        name: "Draft Orders",
        fieldType: FieldType.HasMany,
        key: ShopifyShopToDraftOrdersKey,
        configuration: {
          relatedModelKey: ShopifyDraftOrderKey,
          inverseFieldKey: ShopifyDraftOrderToShopKey,
        },
      },
      {
        name: "Draft Order Line Items",
        fieldType: FieldType.HasMany,
        key: ShopifyShopToDraftOrderLineItemsKey,
        configuration: {
          relatedModelKey: ShopifyDraftOrderLineItemKey,
          inverseFieldKey: ShopifyDraftOrderLineItemToShopKey,
        },
      },
      {
        name: "Duties",
        fieldType: FieldType.HasMany,
        key: ShopifyShopToDutiesKey,
        configuration: {
          relatedModelKey: ShopifyDutyKey,
          inverseFieldKey: ShopifyDutyToShopKey,
        },
      },
      {
        name: "Events",
        fieldType: FieldType.HasMany,
        key: ShopifyShopToEventsKey,
        configuration: {
          relatedModelKey: ShopifyEventKey,
          inverseFieldKey: ShopifyEventToShopKey,
        },
      },
      {
        name: "Files",
        fieldType: FieldType.HasMany,
        key: ShopifyShopToFilesKey,
        configuration: {
          relatedModelKey: ShopifyFileKey,
          inverseFieldKey: ShopifyFileToShopKey,
        },
      },
      {
        name: "Fulfillment Events",
        fieldType: FieldType.HasMany,
        key: ShopifyShopToFulfillmentEventsKey,
        configuration: {
          relatedModelKey: ShopifyFulfillmentEventKey,
          inverseFieldKey: ShopifyFulfillmentEventToShopKey,
        },
      },
      {
        name: "Fulfillments",
        fieldType: FieldType.HasMany,
        key: ShopifyShopToFulfillmentsKey,
        configuration: {
          relatedModelKey: ShopifyFulfillmentKey,
          inverseFieldKey: ShopifyFulfillmentToShopKey,
        },
      },
      {
        name: "Fulfillment Line Items",
        fieldType: FieldType.HasMany,
        key: ShopifyShopToFulfillmentLineItemsKey,
        configuration: {
          relatedModelKey: ShopifyFulfillmentLineItemKey,
          inverseFieldKey: ShopifyFulfillmentLineItemToShopKey,
        },
      },
      {
        name: "Fulfillment Orders",
        fieldType: FieldType.HasMany,
        key: ShopifyShopToFulfillmentOrdersKey,
        configuration: {
          relatedModelKey: ShopifyFulfillmentOrderKey,
          inverseFieldKey: ShopifyFulfillmentOrderToShopKey,
        },
      },
      {
        name: "Fulfillment Order Line Items",
        fieldType: FieldType.HasMany,
        key: ShopifyShopToFulfillmentOrderLineItemsKey,
        configuration: {
          relatedModelKey: ShopifyFulfillmentOrderLineItemKey,
          inverseFieldKey: ShopifyFulfillmentOrderLineItemToShopKey,
        },
      },
      {
        name: "Fulfillment Services",
        fieldType: FieldType.HasMany,
        key: ShopifyShopToFulfillmentServicesKey,
        configuration: {
          relatedModelKey: ShopifyFulfillmentServiceKey,
          inverseFieldKey: ShopifyFulfillmentServiceToShopKey,
        },
      },
      {
        name: "Gift Cards",
        fieldType: FieldType.HasMany,
        key: ShopifyShopToGiftCardsKey,
        configuration: {
          relatedModelKey: ShopifyGiftCardKey,
          inverseFieldKey: ShopifyGiftCardToShopKey,
        },
      },
      {
        name: "Inventory Items",
        fieldType: FieldType.HasMany,
        key: ShopifyShopToInventoryItemsKey,
        configuration: {
          relatedModelKey: ShopifyInventoryItemKey,
          inverseFieldKey: ShopifyInventoryItemToShopKey,
        },
      },
      {
        name: "Inventory Levels",
        fieldType: FieldType.HasMany,
        key: ShopifyShopToInventoryLevelsKey,
        configuration: {
          relatedModelKey: ShopifyInventoryLevelKey,
          inverseFieldKey: ShopifyInventoryLevelToShopKey,
        },
      },
      {
        name: "Locations",
        fieldType: FieldType.HasMany,
        key: ShopifyShopToLocationsKey,
        configuration: {
          relatedModelKey: ShopifyLocationKey,
          inverseFieldKey: ShopifyLocationToShopKey,
        },
      },
      {
        name: "Price Rules",
        fieldType: FieldType.HasMany,
        key: ShopifyShopToPriceRulesKey,
        configuration: {
          relatedModelKey: ShopifyPriceRuleKey,
          inverseFieldKey: ShopifyPriceRuleToShopKey,
        },
      },
      {
        name: "Product Images",
        fieldType: FieldType.HasMany,
        key: ShopifyShopToProductImagesKey,
        configuration: {
          relatedModelKey: ShopifyProductImageKey,
          inverseFieldKey: ShopifyProductImageToShopKey,
        },
      },
      {
        name: "Products",
        fieldType: FieldType.HasMany,
        key: ShopifyShopToProductsKey,
        configuration: {
          relatedModelKey: ShopifyProductKey,
          inverseFieldKey: ShopifyProductToShopKey,
        },
      },
      {
        name: "Product Options",
        fieldType: FieldType.HasMany,
        key: ShopifyShopToProductOptionsKey,
        configuration: {
          relatedModelKey: ShopifyProductOptionKey,
          inverseFieldKey: ShopifyProductOptionToShopKey,
        },
      },
      {
        name: "Product Variants",
        fieldType: FieldType.HasMany,
        key: ShopifyShopToProductVariantsKey,
        configuration: {
          relatedModelKey: ShopifyProductVariantKey,
          inverseFieldKey: ShopifyProductVariantToShopKey,
        },
      },
      {
        name: "Provinces",
        fieldType: FieldType.HasMany,
        key: ShopifyShopToProvincesKey,
        configuration: {
          relatedModelKey: ShopifyProvinceKey,
          inverseFieldKey: ShopifyProvinceToShopKey,
        },
      },
      {
        name: "Tender Transactions",
        fieldType: FieldType.HasMany,
        key: ShopifyShopToTenderTransactionsKey,
        configuration: {
          relatedModelKey: ShopifyTenderTransactionKey,
          inverseFieldKey: ShopifyTenderTransactionToShopKey,
        },
      },
      {
        name: "Orders",
        fieldType: FieldType.HasMany,
        key: ShopifyShopToOrdersKey,
        configuration: {
          relatedModelKey: ShopifyOrderKey,
          inverseFieldKey: ShopifyOrderToShopKey,
        },
      },
      {
        name: "Order Adjustments",
        fieldType: FieldType.HasMany,
        key: ShopifyShopToOrderAdjustmentsKey,
        configuration: {
          relatedModelKey: ShopifyOrderAdjustmentKey,
          inverseFieldKey: ShopifyOrderAdjustmentToShopKey,
        },
      },
      {
        name: "Order Line Items",
        fieldType: FieldType.HasMany,
        key: ShopifyShopToOrderLineItemsKey,
        configuration: {
          relatedModelKey: ShopifyOrderLineItemKey,
          inverseFieldKey: ShopifyOrderLineItemToShopKey,
        },
      },
      {
        name: "Order Risks",
        fieldType: FieldType.HasMany,
        key: ShopifyShopToOrderRisksKey,
        configuration: {
          relatedModelKey: ShopifyOrderRiskKey,
          inverseFieldKey: ShopifyOrderRiskToShopKey,
        },
      },
      {
        name: "Order Transactions",
        fieldType: FieldType.HasMany,
        key: ShopifyShopToOrderTransactionsKey,
        configuration: {
          relatedModelKey: ShopifyOrderTransactionKey,
          inverseFieldKey: ShopifyOrderTransactionToShopKey,
        },
      },
      {
        name: "Articles",
        fieldType: FieldType.HasMany,
        key: ShopifyShopToArticlesKey,
        configuration: {
          relatedModelKey: ShopifyArticleKey,
          inverseFieldKey: ShopifyArticleToShopKey,
        },
      },
      {
        name: "Blogs",
        fieldType: FieldType.HasMany,
        key: ShopifyShopToBlogsKey,
        configuration: {
          relatedModelKey: ShopifyBlogKey,
          inverseFieldKey: ShopifyBlogToShopKey,
        },
      },
      {
        name: "Carrier Services",
        fieldType: FieldType.HasMany,
        key: ShopifyShopToCarrierServicesKey,
        configuration: {
          relatedModelKey: ShopifyCarrierServiceKey,
          inverseFieldKey: ShopifyCarrierServiceToShopKey,
        },
      },
      {
        name: "Comments",
        fieldType: FieldType.HasMany,
        key: ShopifyShopToCommentsKey,
        configuration: {
          relatedModelKey: ShopifyCommentKey,
          inverseFieldKey: ShopifyCommentToShopKey,
        },
      },
      {
        name: "Countries",
        fieldType: FieldType.HasMany,
        key: ShopifyShopToCountriesKey,
        configuration: {
          relatedModelKey: ShopifyCountryKey,
          inverseFieldKey: ShopifyCountryToShopKey,
        },
      },
      {
        name: "Assets",
        fieldType: FieldType.HasMany,
        key: ShopifyShopToAssetsKey,
        configuration: {
          relatedModelKey: ShopifyAssetKey,
          inverseFieldKey: ShopifyAssetToShopKey,
        },
      },
      {
        name: "Themes",
        fieldType: FieldType.HasMany,
        key: ShopifyShopToThemesKey,
        configuration: {
          relatedModelKey: ShopifyThemeKey,
          inverseFieldKey: ShopifyThemeToShopKey,
        },
      },
      {
        name: "Script Tags",
        fieldType: FieldType.HasMany,
        key: ShopifyShopToScriptTagsKey,
        configuration: {
          relatedModelKey: ShopifyScriptTagKey,
          inverseFieldKey: ShopifyScriptTagToShopKey,
        },
      },
      {
        name: "Pages",
        fieldType: FieldType.HasMany,
        key: ShopifyShopToPagesKey,
        configuration: {
          relatedModelKey: ShopifyPageKey,
          inverseFieldKey: ShopifyPageToShopKey,
        },
      },
      {
        name: "Redirects",
        fieldType: FieldType.HasMany,
        key: ShopifyShopToRedirectsKey,
        configuration: {
          relatedModelKey: ShopifyRedirectKey,
          inverseFieldKey: ShopifyRedirectToShopKey,
        },
      },
      {
        name: "Refunds",
        fieldType: FieldType.HasMany,
        key: ShopifyShopToRefundsKey,
        configuration: {
          relatedModelKey: ShopifyRefundKey,
          inverseFieldKey: ShopifyRefundToShopKey,
        },
      },
      {
        name: "Payouts",
        fieldType: FieldType.HasMany,
        key: ShopifyShopToPayoutsKey,
        configuration: {
          relatedModelKey: ShopifyPayoutKey,
          inverseFieldKey: ShopifyPayoutToShopKey,
        },
      },
      {
        name: "Refund Duties",
        fieldType: FieldType.HasMany,
        key: ShopifyShopToRefundDutiesKey,
        configuration: {
          relatedModelKey: ShopifyRefundDutyKey,
          inverseFieldKey: ShopifyRefundDutyToShopKey,
        },
      },
      {
        name: "Refund Line Items",
        fieldType: FieldType.HasMany,
        key: ShopifyShopToRefundLineItemsKey,
        configuration: {
          relatedModelKey: ShopifyRefundLineItemKey,
          inverseFieldKey: ShopifyRefundLineItemToShopKey,
        },
      },
      {
        name: "Shipping Lines",
        fieldType: FieldType.HasMany,
        key: ShopifyShopToShippingLinesKey,
        configuration: {
          relatedModelKey: ShopifyShippingLineKey,
          inverseFieldKey: ShopifyShippingLineToShopKey,
        },
      },
      {
        name: "Checkouts",
        fieldType: FieldType.HasMany,
        key: ShopifyShopToCheckoutsKey,
        configuration: {
          relatedModelKey: ShopifyCheckoutKey,
          inverseFieldKey: ShopifyCheckoutToShopKey,
        },
      },
      {
        name: "Checkout Line Items",
        fieldType: FieldType.HasMany,
        key: ShopifyShopToCheckoutLineItemsKey,
        configuration: {
          relatedModelKey: ShopifyCheckoutLineItemKey,
          inverseFieldKey: ShopifyCheckoutLineItemToShopKey,
        },
      },
      {
        name: "Checkout Shipping Rates",
        fieldType: FieldType.HasMany,
        key: ShopifyShopToCheckoutShippingRatesKey,
        configuration: {
          relatedModelKey: ShopifyCheckoutShippingRateKey,
          inverseFieldKey: ShopifyCheckoutShippingRateToShopKey,
        },
      },
      {
        name: "Checkout Applied Gift Cards",
        fieldType: FieldType.HasMany,
        key: ShopifyShopToCheckoutAppliedGiftCardsKey,
        configuration: {
          relatedModelKey: ShopifyCheckoutAppliedGiftCardKey,
          inverseFieldKey: ShopifyCheckoutAppliedGiftCardToShopKey,
        },
      },
      {
        name: "Billing Addresses",
        fieldType: FieldType.HasMany,
        key: ShopifyShopToBillingAddressesKey,
        configuration: {
          relatedModelKey: ShopifyBillingAddressKey,
          inverseFieldKey: ShopifyBillingAddressToShopKey,
        },
      },
      {
        name: "Shipping Addresses",
        fieldType: FieldType.HasMany,
        key: ShopifyShopToShippingAddressesKey,
        configuration: {
          relatedModelKey: ShopifyShippingAddressKey,
          inverseFieldKey: ShopifyShippingAddressToShopKey,
        },
      },
      {
        name: "Disputes",
        fieldType: FieldType.HasMany,
        key: ShopifyShopToDisputesKey,
        configuration: {
          relatedModelKey: ShopifyDisputeKey,
          inverseFieldKey: ShopifyDisputeToShopKey,
        },
      },
      {
        name: "Selling Plan Groups Products",
        fieldType: FieldType.HasMany,
        key: ShopifyShopToSellingPlanGroupsProductsKey,
        configuration: {
          relatedModelKey: ShopifySellingPlanGroupProductKey,
          inverseFieldKey: ShopifySellingPlanGroupProductToShopKey,
        },
      },
      {
        name: "Selling Plan Groups Product Variants",
        fieldType: FieldType.HasMany,
        key: ShopifyShopToSellingPlanGroupsProductVariantsKey,
        configuration: {
          relatedModelKey: ShopifySellingPlanGroupProductVariantKey,
          inverseFieldKey: ShopifySellingPlanGroupProductVariantToShopKey,
        },
      },
      {
        name: "Selling Plan Groups",
        fieldType: FieldType.HasMany,
        key: ShopifyShopToSellingPlanGroupsKey,
        configuration: {
          relatedModelKey: ShopifySellingPlanGroupKey,
          inverseFieldKey: ShopifySellingPlanGroupToShopKey,
        },
      },
      {
        name: "Selling Plans",
        fieldType: FieldType.HasMany,
        key: ShopifyShopToSellingPlansKey,
        configuration: {
          relatedModelKey: ShopifySellingPlanKey,
          inverseFieldKey: ShopifySellingPlanToShopKey,
        },
      },
      {
        name: "Subscription Billing Attempts",
        fieldType: FieldType.HasMany,
        key: ShopifyShopToSubscriptionBillingAttemptsKey,
        configuration: {
          relatedModelKey: ShopifySubscriptionBillingAttemptKey,
          inverseFieldKey: ShopifySubscriptionBillingAttemptToShopKey,
        },
      },
      {
        name: "Subscription Contracts",
        fieldType: FieldType.HasMany,
        key: ShopifyShopToSubscriptionContractsKey,
        configuration: {
          relatedModelKey: ShopifySubscriptionContractKey,
          inverseFieldKey: ShopifySubscriptionContractToShopKey,
        },
      },
      {
        name: "Subscription Lines",
        fieldType: FieldType.HasMany,
        key: ShopifyShopToSubscriptionLinesKey,
        configuration: {
          relatedModelKey: ShopifySubscriptionLineKey,
          inverseFieldKey: ShopifySubscriptionLineToShopKey,
        },
      },
      {
        name: "Manual Discounts",
        fieldType: FieldType.HasMany,
        key: ShopifyShopToManualDiscountsKey,
        configuration: {
          relatedModelKey: ShopifySubscriptionManualDiscountKey,
          inverseFieldKey: ShopifySubscriptionManualDiscountToShopKey,
        },
      },
      {
        name: "Syncs",
        fieldType: FieldType.HasMany,
        key: ShopifyShopToSyncsKey,
        configuration: {
          relatedModelKey: ShopifySyncKey,
          inverseFieldKey: ShopifySyncToShopKey,
        },
      },
      {
        name: "GDPR Requests",
        fieldType: FieldType.HasMany,
        key: ShopifyShopToGDPRRequestsKey,
        configuration: {
          relatedModelKey: ShopifyGdprRequestKey,
          inverseFieldKey: ShopifyGdprRequestToShopKey,
        },
      },
      {
        name: "Bulk Operations",
        fieldType: FieldType.HasMany,
        key: ShopifyShopToBulkOperationsKey,
        configuration: {
          relatedModelKey: ShopifyBulkOperationKey,
          inverseFieldKey: ShopifyBulkOperationToShopKey,
        },
      },
      {
        key: ShopifyShopGrantedScopesKey,
        name: "Granted Scopes",
        fieldType: FieldType.JSON,
        dominionID: GadgetSystemDominionId,
        contributorConfiguration: {
          [GadgetSystemDominionId]: {
            isWritableInternally: true,
            storeInColumn: false,
          },
        },
      },
      {
        key: ShopifyShopRegisteredWebhooksKey,
        name: "Registered Webhooks",
        fieldType: FieldType.JSON,
        dominionID: GadgetSystemDominionId,
        isDeleted: doesVersionSupportShopifyAppPlatform,
        contributorConfiguration: {
          [GadgetSystemDominionId]: {
            isWritableInternally: true,
            storeInColumn: false,
          },
        },
      },
      {
        key: ShopifyShopSpecificRegistrationKey,
        name: "Shop Specific Registration",
        fieldType: FieldType.JSON,
        dominionID: GadgetSystemDominionId,
        frameworkVersionConstraint: ">=1.7.0",
        contributorConfiguration: {
          [GadgetSystemDominionId]: {
            isWritableInternally: true,
            storeInColumn: false,
          },
        },
      },
      {
        key: ShopifyShopAccessTokenKey,
        name: "Access Token",
        fieldType: FieldType.EncryptedString,
        apiExposedOverride: false,
        dominionID: GadgetSystemDominionId,
        contributorConfiguration: {
          [GadgetSystemDominionId]: {
            isWritableInternally: true,
            storeInColumn: false,
          },
        },
      },
      {
        key: ShopifyShopInstalledViaAPIKeyKey,
        name: "Installed Via API Key",
        fieldType: FieldType.String,
        dominionID: GadgetSystemDominionId,
        contributorConfiguration: {
          [GadgetSystemDominionId]: {
            isWritableInternally: true,
            storeInColumn: false,
          },
        },
      },
      {
        key: ShopifyShopDisabledWebhooksKey,
        name: "Disabled Webhooks",
        fieldType: FieldType.JSON,
        dominionID: GadgetSystemDominionId,
        frameworkVersionConstraint: ">=0.3.1 <1.7.0",
        contributorConfiguration: {
          [GadgetSystemDominionId]: {
            isWritableInternally: true,
            storeInColumn: false,
          },
        },
      },
    ],
    stateChart: {
      includeCRUD: true,
      crudOptions: {
        defaultActionKeys: {
          create: ShopifyShopInstallKey,
          update: ShopifyShopUpdateKey,
        },
        defaultActionNames: {
          create: "Install",
        },
      },
      states: {
        created: [
          {
            key: ShopifyShopInstalledKey,
            name: "Installed",
            color: "#67CA48",
            boxLayout: { x: 8, y: 56, width: 160, height: 48 },
          },
          {
            key: ShopifyShopUninstalledKey,
            name: "Uninstalled",
            color: "#E2CD2E",
            boxLayout: { x: 264, y: 200, width: 168, height: 48 },
          },
        ],
      },
      actions: [
        {
          key: ShopifyShopUninstallKey,
          name: "Uninstall",
          from: "installed",
          to: "uninstalled",
          allowActionDeletion: false,
          onRunEffects: [
            {
              specID: ApplyParamsRecordEffectSpecID,
            },
            {
              specID: UpdateRecordEffectSpecID,
            },
          ],
        },
        {
          key: ShopifyShopReinstallKey,
          name: "Reinstall",
          from: "uninstalled",
          to: "installed",
          allowActionDeletion: false,
          onRunEffects: [
            {
              specID: ApplyParamsRecordEffectSpecID,
            },
            {
              specID: UpdateRecordEffectSpecID,
            },
          ],
        },
      ],
    },
    syncConfig: { type: "custom", resource: "shop" }, // Special case, syncs with `get` instead of `list`
  },
  "2022-04": {
    fields: [
      {
        name: "Markets",
        fieldType: FieldType.HasMany,
        key: ShopifyShopToMarketsKey,
        configuration: {
          relatedModelKey: ShopifyMarketKey,
          inverseFieldKey: ShopifyMarketToShopKey,
        },
      },
      {
        name: "Market Regions",
        fieldType: FieldType.HasMany,
        key: ShopifyShopToMarketRegionsKey,
        configuration: {
          relatedModelKey: ShopifyMarketRegionKey,
          inverseFieldKey: ShopifyMarketRegionToShopKey,
        },
      },
      {
        name: "Market Web Presences",
        fieldType: FieldType.HasMany,
        key: ShopifyShopToMarketWebPresencesKey,
        configuration: {
          relatedModelKey: ShopifyMarketWebPresenceKey,
          inverseFieldKey: ShopifyMarketWebPresenceToShopKey,
        },
      },
    ],
  },
  "2022-07": {
    fields: [
      {
        name: "Dispute Evidences",
        fieldType: FieldType.HasMany,
        key: ShopifyShopToDisputeEvidencesKey,
        configuration: {
          relatedModelKey: ShopifyDisputeEvidenceKey,
          inverseFieldKey: ShopifyDisputeEvidenceToShopKey,
        },
      },
      {
        name: "Dispute File Uploads",
        fieldType: FieldType.HasMany,
        key: ShopifyShopToDisputeFileUploadsKey,
        configuration: {
          relatedModelKey: ShopifyDisputeFileUploadKey,
          inverseFieldKey: ShopifyDisputeFileUploadToShopKey,
        },
      },
      {
        name: "Dispute Evidence Fulfillments",
        fieldType: FieldType.HasMany,
        key: ShopifyShopToDisputeEvidenceFulfillmentsKey,
        configuration: {
          relatedModelKey: ShopifyDisputeEvidenceFulfillmentKey,
          inverseFieldKey: ShopifyDisputeEvidenceFulfillmentToShopKey,
        },
      },
      {
        name: "Discounts",
        fieldType: FieldType.HasMany,
        key: ShopifyShopToDiscountsKey,
        configuration: {
          relatedModelKey: ShopifyDiscountKey,
          inverseFieldKey: ShopifyDiscountToShopKey,
        },
      },
    ],
  },
  "2022-10": {
    fields: [
      {
        name: "Transactional SMS Disabled",
        fieldType: FieldType.Boolean,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "transactional_sms_disabled" } },
      },
      {
        name: "Marketing SMS Content Enabled at Checkout",
        fieldType: FieldType.Boolean,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "marketing_sms_consent_enabled_at_checkout" } },
      },
    ],
  },
  "2023-04": {
    fields: [
      {
        name: "Company",
        fieldType: FieldType.HasMany,
        key: ShopifyShopToCompaniesKey,
        configuration: {
          relatedModelKey: ShopifyCompanyKey,
          inverseFieldKey: ShopifyCompanyToShopKey,
        },
      },
      {
        name: "Company Contact",
        fieldType: FieldType.HasMany,
        key: ShopifyShopToCompanyContactsKey,
        configuration: {
          relatedModelKey: ShopifyCompanyContactKey,
          inverseFieldKey: ShopifyCompanyContactToShopKey,
        },
      },
      {
        name: "Company Contact Role",
        fieldType: FieldType.HasMany,
        key: ShopifyShopToCompanyContactRolesKey,
        configuration: {
          relatedModelKey: ShopifyCompanyContactRoleKey,
          inverseFieldKey: ShopifyCompanyContactRoleToShopKey,
        },
      },
      {
        name: "Company Contact Role Assignment",
        fieldType: FieldType.HasMany,
        key: ShopifyShopToCompanyContactRoleAssignmentsKey,
        configuration: {
          relatedModelKey: ShopifyCompanyContactRoleAssignmentKey,
          inverseFieldKey: ShopifyCompanyContactRoleAssignmentToShopKey,
        },
      },
      {
        name: "Company Location",
        fieldType: FieldType.HasMany,
        key: ShopifyShopToCompanyLocationsKey,
        configuration: {
          relatedModelKey: ShopifyCompanyLocationKey,
          inverseFieldKey: ShopifyCompanyLocationToShopKey,
        },
      },
      {
        name: "Company Address",
        fieldType: FieldType.HasMany,
        key: ShopifyShopToCompanyAddressesKey,
        configuration: {
          relatedModelKey: ShopifyCompanyAddressKey,
          inverseFieldKey: ShopifyCompanyAddressToShopKey,
        },
      },
    ],
  },
  "2023-07": {
    fields: [
      {
        name: "Discount Redeem Codes",
        fieldType: FieldType.HasMany,
        key: ShopifyShopToDiscountRedeemCodesKey,
        configuration: {
          relatedModelKey: ShopifyDiscountRedeemCodeKey,
          inverseFieldKey: ShopifyDiscountRedeemCodeToShopKey,
        },
      },
      {
        name: "Discount Customer Buys Collections",
        fieldType: FieldType.HasMany,
        key: ShopifyShopToDiscountCustomerBuysCollectionsKey,
        configuration: {
          relatedModelKey: ShopifyDiscountCustomerBuysCollectionKey,
          inverseFieldKey: ShopifyDiscountCustomerBuysCollectionToShopKey,
        },
      },
      {
        name: "Discount Customer Gets Collections",
        fieldType: FieldType.HasMany,
        key: ShopifyShopToDiscountCustomerGetsCollectionsKey,
        configuration: {
          relatedModelKey: ShopifyDiscountCustomerGetsCollectionKey,
          inverseFieldKey: ShopifyDiscountCustomerGetsCollectionToShopKey,
        },
      },
      {
        name: "Discount Customer Buys Products",
        fieldType: FieldType.HasMany,
        key: ShopifyShopToDiscountCustomerBuysProductsKey,
        configuration: {
          relatedModelKey: ShopifyDiscountCustomerBuysProductKey,
          inverseFieldKey: ShopifyDiscountCustomerBuysProductToShopKey,
        },
      },
      {
        name: "Discount Customer Gets Products",
        fieldType: FieldType.HasMany,
        key: ShopifyShopToDiscountCustomerGetsProductsKey,
        configuration: {
          relatedModelKey: ShopifyDiscountCustomerGetsProductKey,
          inverseFieldKey: ShopifyDiscountCustomerGetsProductToShopKey,
        },
      },
      {
        name: "Discount Customer Buys Product Variants",
        fieldType: FieldType.HasMany,
        key: ShopifyShopToDiscountCustomerBuysProductVariantsKey,
        configuration: {
          relatedModelKey: ShopifyDiscountCustomerBuysProductVariantKey,
          inverseFieldKey: ShopifyDiscountCustomerBuysProductVariantToShopKey,
        },
      },
      {
        name: "Discount Customer Gets Product Variants",
        fieldType: FieldType.HasMany,
        key: ShopifyShopToDiscountCustomerGetsProductVariantsKey,
        configuration: {
          relatedModelKey: ShopifyDiscountCustomerGetsProductVariantKey,
          inverseFieldKey: ShopifyDiscountCustomerGetsProductVariantToShopKey,
        },
      },
    ],
  },
  "2023-10": {
    fields: [
      {
        name: "Customer Accounts V2",
        fieldType: FieldType.JSON,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "__gadget_graphql_shop_customer_accounts_v2",
            graphQLFieldKey: "customerAccountsV2",
            graphQLOnlyField: true,
            graphQLSelection: `
            customerAccountsVersion
            loginLinksVisibleOnStorefrontAndCheckout
            loginRequiredAtCheckout
            url
            `,
          },
        },
      },
    ],
  },
  "2024-01": {
    fields: [
      {
        name: "Plan",
        fieldType: FieldType.JSON,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "__gadget_graphql_shop_plan",
            graphQLFieldKey: "plan",
            graphQLOnlyField: true,
            graphQLSelection: `
            displayName
            partnerDevelopment
            shopifyPlus
            `,
          },
        },
      },
      {
        name: "Payment Terms",
        fieldType: FieldType.HasMany,
        key: ShopifyShopToPaymentTermsKey,
        configuration: {
          relatedModelKey: ShopifyPaymentTermsKey,
          inverseFieldKey: ShopifyPaymentTermsToShopKey,
        },
      },
      {
        name: "Payment Schedule",
        fieldType: FieldType.HasMany,
        key: ShopifyShopToPaymentSchedulesKey,
        configuration: {
          relatedModelKey: ShopifyPaymentScheduleKey,
          inverseFieldKey: ShopifyPaymentScheduleToShopKey,
        },
      },
    ],
  },
  "2024-04": {
    fields: [
      {
        name: "Catalog",
        fieldType: FieldType.HasMany,
        key: ShopifyShopToCatalogsKey,
        configuration: {
          relatedModelKey: ShopifyCatalogKey,
          inverseFieldKey: ShopifyCatalogToShopKey,
        },
      },
      {
        name: "Company Location Catalog",
        fieldType: FieldType.HasMany,
        key: ShopifyShopToCompanyLocationCatalogsKey,
        configuration: {
          relatedModelKey: ShopifyCompanyLocationCatalogKey,
          inverseFieldKey: ShopifyCompanyLocationCatalogToShopKey,
        },
      },
      {
        name: "Market Catalog",
        fieldType: FieldType.HasMany,
        key: ShopifyShopToMarketCatalogsKey,
        configuration: {
          relatedModelKey: ShopifyMarketCatalogKey,
          inverseFieldKey: ShopifyMarketCatalogToShopKey,
        },
      },
      {
        name: "Price List",
        fieldType: FieldType.HasMany,
        key: ShopifyShopToPriceListsKey,
        configuration: {
          relatedModelKey: ShopifyPriceListKey,
          inverseFieldKey: ShopifyPriceListToShopKey,
        },
      },
      {
        name: "Price List Price",
        fieldType: FieldType.HasMany,
        key: ShopifyShopToPriceListPricesKey,
        configuration: {
          relatedModelKey: ShopifyPriceListPriceKey,
          inverseFieldKey: ShopifyPriceListPriceToShopKey,
        },
      },
      {
        name: "Quantity Price Break",
        fieldType: FieldType.HasMany,
        key: ShopifyShopToQuantityPriceBreaksKey,
        configuration: {
          relatedModelKey: ShopifyQuantityPriceBreakKey,
          inverseFieldKey: ShopifyQuantityPriceBreakToShopKey,
        },
      },
    ],
  },
  "2024-07": {
    fields: [
      {
        name: "Draft Order Platform Discount",
        fieldType: FieldType.HasMany,
        key: ShopifyShopToDraftOrderPlatformDiscountsKey,
        configuration: {
          relatedModelKey: ShopifyDraftOrderPlatformDiscountKey,
          inverseFieldKey: ShopifyDraftOrderPlatformDiscountToShopKey,
        },
      },
      {
        name: "Draft Order Platform Discount Allocation",
        fieldType: FieldType.HasMany,
        key: ShopifyShopToDraftOrderPlatformDiscountAllocationsKey,
        configuration: {
          relatedModelKey: ShopifyDraftOrderPlatformDiscountAllocationKey,
          inverseFieldKey: ShopifyDraftOrderPlatformDiscountAllocationToShopKey,
        },
      },
      {
        name: "Product Media",
        fieldType: FieldType.HasMany,
        key: ShopifyShopToProductMediaKey,
        configuration: {
          relatedModelKey: ShopifyProductMediaKey,
          inverseFieldKey: ShopifyProductMediaToShopKey,
        },
      },
      {
        name: "Product Variant Media",
        fieldType: FieldType.HasMany,
        key: ShopifyShopToProductVariantMediaKey,
        configuration: {
          relatedModelKey: ShopifyProductVariantMediaKey,
          inverseFieldKey: ShopifyProductVariantMediaToShopKey,
        },
      },
      {
        name: "Store Credit Account",
        fieldType: FieldType.HasMany,
        key: ShopifyShopToStoreCreditAccountsKey,
        configuration: {
          relatedModelKey: ShopifyStoreCreditAccountKey,
          inverseFieldKey: ShopifyStoreCreditAccountToShopKey,
        },
      },
      {
        name: "Returns",
        fieldType: FieldType.HasMany,
        key: ShopifyShopToReturnsKey,
        configuration: {
          relatedModelKey: ShopifyReturnKey,
          inverseFieldKey: ShopifyReturnToShopKey,
        },
      },
      {
        name: "Return Shipping Fees",
        fieldType: FieldType.HasMany,
        key: ShopifyShopToReturnShippingFeesKey,
        configuration: {
          relatedModelKey: ShopifyReturnShippingFeeKey,
          inverseFieldKey: ShopifyReturnShippingFeeToShopKey,
        },
      },
      {
        name: "Reverse Fulfillment Orders",
        fieldType: FieldType.HasMany,
        key: ShopifyShopToReverseFulfillmentOrdersKey,
        configuration: {
          relatedModelKey: ShopifyReverseFulfillmentOrderKey,
          inverseFieldKey: ShopifyReverseFulfillmentOrderToShopKey,
        },
      },
      {
        name: "Reverse Fulfillment Order Line Items",
        fieldType: FieldType.HasMany,
        key: ShopifyShopToReverseFulfillmentOrderLineItemsKey,
        configuration: {
          relatedModelKey: ShopifyReverseFulfillmentOrderLineItemKey,
          inverseFieldKey: ShopifyReverseFulfillmentOrderLineItemToShopKey,
        },
      },
      {
        name: "Reverse Fulfillment Order Dispositions",
        fieldType: FieldType.HasMany,
        key: ShopifyShopToReverseFulfillmentOrderDispositionsKey,
        configuration: {
          relatedModelKey: ShopifyReverseFulfillmentOrderDispositionKey,
          inverseFieldKey: ShopifyReverseFulfillmentOrderDispositionToShopKey,
        },
      },
      {
        name: "Reverse Deliveries",
        fieldType: FieldType.HasMany,
        key: ShopifyShopToReverseDeliveriesKey,
        configuration: {
          relatedModelKey: ShopifyReverseDeliveryKey,
          inverseFieldKey: ShopifyReverseDeliveryToShopKey,
        },
      },
      {
        name: "Reverse Delivery Line Items",
        fieldType: FieldType.HasMany,
        key: ShopifyShopToReverseDeliveryLineItemsKey,
        configuration: {
          relatedModelKey: ShopifyReverseDeliveryLineItemKey,
          inverseFieldKey: ShopifyReverseDeliveryLineItemToShopKey,
        },
      },
      {
        name: "Exchange Line Items",
        fieldType: FieldType.HasMany,
        key: ShopifyShopToExchangeLineItemsKey,
        configuration: {
          relatedModelKey: ShopifyExchangeLineItemKey,
          inverseFieldKey: ShopifyExchangeLineItemToShopKey,
        },
      },
      {
        name: "Return Line Items",
        fieldType: FieldType.HasMany,
        key: ShopifyShopToReturnLineItemsKey,
        configuration: {
          relatedModelKey: ShopifyReturnLineItemKey,
          inverseFieldKey: ShopifyReturnLineItemToShopKey,
        },
      },
    ],
  },
  "2024-10": {
    fields: [
      {
        name: "Shopify Payments Account",
        fieldType: FieldType.HasOne,
        key: ShopifyShopToPaymentsAccountKey,
        configuration: {
          relatedModelKey: ShopifyPaymentsAccountKey,
          inverseFieldKey: ShopifyPaymentsAccountToShopKey,
        },
      },
      {
        name: "Shopify Business Entity",
        fieldType: FieldType.HasMany,
        key: ShopifyShopToBusinessEntitiesKey,
        configuration: {
          relatedModelKey: ShopifyBusinessEntityKey,
          inverseFieldKey: ShopifyBusinessEntityToShopKey,
        },
      },
      {
        name: "Segments",
        fieldType: FieldType.HasMany,
        key: ShopifyShopToSegmentsKey,
        configuration: {
          relatedModelKey: ShopifySegmentKey,
          inverseFieldKey: ShopifySegmentToShopKey,
        },
      },
    ],
  },
  "2025-04": {
    fields: [
      {
        name: "Transactional SMS Disabled",
        fieldType: FieldType.Boolean,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "transactional_sms_disabled",
            availableInWebhook: ["shop/update", "app/uninstalled"],
          },
        },
      },
      {
        name: "Marketing SMS Content Enabled at Checkout",
        fieldType: FieldType.Boolean,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "marketing_sms_consent_enabled_at_checkout",
            availableInWebhook: ["shop/update", "app/uninstalled"],
          },
        },
      },
      {
        name: "Shopify Delivery Method",
        fieldType: FieldType.HasMany,
        key: ShopifyShopToDeliveryMethodKey,
        configuration: {
          relatedModelKey: ShopifyDeliveryMethodKey,
          inverseFieldKey: ShopifyDeliveryMethodToShopKey,
        },
      },
      {
        name: "Shopify Fulfillment Hold",
        fieldType: FieldType.HasMany,
        key: ShopifyShopToFulfillmentHoldKey,
        configuration: {
          relatedModelKey: ShopifyFulfillmentHoldKey,
          inverseFieldKey: ShopifyFulfillmentHoldToShopKey,
        },
      },
      {
        name: "Shopify Fulfillment Order Destination",
        fieldType: FieldType.HasMany,
        key: ShopifyShopToFulfillmentOrderDestinationKey,
        configuration: {
          relatedModelKey: ShopifyFulfillmentOrderDestinationKey,
          inverseFieldKey: ShopifyFulfillmentOrderDestinationToShopKey,
        },
      },
      {
        name: "Shopify Fulfillment Order Merchant Request",
        fieldType: FieldType.HasMany,
        key: ShopifyShopToFulfillmentOrderMerchantRequestKey,
        configuration: {
          relatedModelKey: ShopifyFulfillmentOrderMerchantRequestKey,
          inverseFieldKey: ShopifyFulfillmentOrderMerchantRequestToShopKey,
        },
      },
      {
        name: "Shopify Inventory Quantity",
        fieldType: FieldType.HasMany,
        key: ShopifyShopToInventoryQuantityKey,
        configuration: {
          relatedModelKey: ShopifyInventoryQuantityKey,
          inverseFieldKey: ShopifyInventoryQuantityToShopKey,
        },
      },
      {
        name: "Address 1",
        fieldType: FieldType.String,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "address1",
            graphQLFieldKey: "address1",
            skipGraphQLSelection: true,
            availableInWebhook: ["shop/update", "app/uninstalled"],
          },
        },
      },
      {
        name: "Address 2",
        fieldType: FieldType.String,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "address2",
            graphQLFieldKey: "address2",
            skipGraphQLSelection: true,
            availableInWebhook: ["shop/update", "app/uninstalled"],
          },
        },
      },
      {
        name: "Checkout API Supported",
        fieldType: FieldType.Boolean,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "checkout_api_supported",
            graphQLFieldKey: "checkoutApiSupported",
            availableInWebhook: ["shop/update", "app/uninstalled"],
          },
        },
      },
      {
        name: "City",
        fieldType: FieldType.String,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "city",
            graphQLFieldKey: "city",
            skipGraphQLSelection: true,
            availableInWebhook: ["shop/update", "app/uninstalled"],
          },
        },
      },
      {
        name: "Cookie Consent Level",
        fieldType: FieldType.String,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "cookie_consent_level" } },
        isDeleted: true,
      },
      {
        name: "Country",
        fieldType: FieldType.String,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "country",
            graphQLFieldKey: "country",
            skipGraphQLSelection: true,
            availableInWebhook: ["shop/update", "app/uninstalled"],
          },
        },
      },
      {
        name: "Country Code",
        fieldType: FieldType.String,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "country_code",
            graphQLFieldKey: "countryCodeV2",
            skipGraphQLSelection: true,
            availableInWebhook: ["shop/update", "app/uninstalled"],
          },
        },
      },
      {
        name: "Country Name",
        fieldType: FieldType.String,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "country_name",
            graphQLFieldKey: "countryName",
            skipGraphQLSelection: true,
            availableInWebhook: ["shop/update", "app/uninstalled"],
          },
        },
      },
      {
        name: "County Taxes",
        fieldType: FieldType.JSON,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "county_taxes",
            deprecated: true,
            availableInWebhook: ["shop/update", "app/uninstalled"],
          },
        },
      },
      {
        name: "Currency",
        fieldType: FieldType.Enum,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "currency",
            graphQLFieldKey: "currencyCode",
            isShopifyEnum: true,
            availableInWebhook: ["shop/update", "app/uninstalled"],
          },
        },
        configuration: {
          allowOther: true,
          allowMultiple: false,
          options: shopifyCurrencyCodeEnumOptions,
        },
      },
      {
        name: "Customer Email",
        fieldType: FieldType.String,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "customer_email",
            graphQLFieldKey: "contactEmail",
            availableInWebhook: ["shop/update", "app/uninstalled"],
          },
        },
      },
      {
        name: "Domain",
        fieldType: FieldType.String,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "domain",
            graphQLFieldKey: "primaryDomain",
            graphQLSelection: "host",
            availableInWebhook: ["shop/update", "app/uninstalled"],
          },
        },
      },
      {
        name: "Eligible For Card Reader Giveaway",
        fieldType: FieldType.Boolean,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "eligible_for_card_reader_giveaway",
          },
        },
        isDeleted: true,
      },
      {
        name: "Eligible For Payments",
        fieldType: FieldType.Boolean,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "eligible_for_payments",
            deprecated: true,
            availableInWebhook: ["shop/update", "app/uninstalled"],
          },
        },
      },
      {
        name: "Email",
        fieldType: FieldType.String,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "email",
            graphQLFieldKey: "email",
            availableInWebhook: ["shop/update", "app/uninstalled"],
          },
        },
      },
      {
        name: "Enabled Presentment Currencies",
        fieldType: FieldType.Enum,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "enabled_presentment_currencies",
            graphQLFieldKey: "enabledPresentmentCurrencies",
            isShopifyEnum: true,
            availableInWebhook: ["shop/update", "app/uninstalled"],
          },
        },
        configuration: {
          allowOther: true,
          allowMultiple: true,
          options: shopifyCurrencyCodeEnumOptions,
        },
      },
      {
        name: "Finances",
        fieldType: FieldType.Boolean,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "finances",
            deprecated: true,
            availableInWebhook: ["shop/update", "app/uninstalled"],
          },
        },
      },
      {
        name: "Force SSL",
        fieldType: FieldType.Boolean,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "force_ssl" } },
        isDeleted: true,
      },
      {
        name: "Google Apps Domain",
        fieldType: FieldType.String,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "google_apps_domain",
            deprecated: true,
            availableInWebhook: ["shop/update", "app/uninstalled"],
          },
        },
      },
      {
        name: "Google Apps Login Enabled",
        fieldType: FieldType.Boolean,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "google_apps_login_enabled",
            deprecated: true,
            availableInWebhook: ["shop/update", "app/uninstalled"],
          },
        },
      },
      {
        name: "Has Discounts",
        fieldType: FieldType.Boolean,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "has_discounts",
            deprecated: true,
            availableInWebhook: ["shop/update", "app/uninstalled"],
          },
        },
      },
      {
        name: "Has Gift Cards",
        fieldType: FieldType.Boolean,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "has_gift_cards",
            deprecated: true,
            availableInWebhook: ["shop/update", "app/uninstalled"],
          },
        },
      },
      {
        name: "Has Storefront",
        fieldType: FieldType.Boolean,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "has_storefront",
            deprecated: true,
            availableInWebhook: ["shop/update", "app/uninstalled"],
          },
        },
      },
      {
        name: "Iana Timezone",
        fieldType: FieldType.String,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "iana_timezone",
            graphQLFieldKey: "ianaTimezone",
            availableInWebhook: ["shop/update", "app/uninstalled"],
          },
        },
      },
      {
        name: "ID",
        fieldType: FieldType.ID,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "id",
            graphQLFieldKey: "id",
            availableInWebhook: ["shop/update", "app/uninstalled"],
          },
        },
      },
      {
        name: "Latitude",
        fieldType: FieldType.Number,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "latitude",
            graphQLFieldKey: "latitude",
            skipGraphQLSelection: true,
            availableInWebhook: ["shop/update", "app/uninstalled"],
          },
        },
      },
      {
        name: "Longitude",
        fieldType: FieldType.Number,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "longitude",
            graphQLFieldKey: "longitude",
            skipGraphQLSelection: true,
            availableInWebhook: ["shop/update", "app/uninstalled"],
          },
        },
      },
      {
        name: "Money Format",
        fieldType: FieldType.String,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "money_format",
            graphQLFieldKey: "moneyFormat",
            skipGraphQLSelection: true,
            availableInWebhook: ["shop/update", "app/uninstalled"],
          },
        },
      },
      {
        name: "Money In Emails Format",
        fieldType: FieldType.String,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "money_in_emails_format",
            graphQLFieldKey: "moneyInEmailsFormat",
            skipGraphQLSelection: true,
            availableInWebhook: ["shop/update", "app/uninstalled"],
          },
        },
      },
      {
        name: "Money With Currency Format",
        fieldType: FieldType.String,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "money_with_currency_format",
            graphQLFieldKey: "moneyWithCurrencyFormat",
            skipGraphQLSelection: true,
            availableInWebhook: ["shop/update", "app/uninstalled"],
          },
        },
      },
      {
        name: "Money With Currency In Emails Format",
        fieldType: FieldType.String,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "money_with_currency_in_emails_format",
            graphQLFieldKey: "moneyWithCurrencyInEmailsFormat",
            skipGraphQLSelection: true,
            availableInWebhook: ["shop/update", "app/uninstalled"],
          },
        },
      },
      {
        name: "Multi Location Enabled",
        fieldType: FieldType.Boolean,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "multi_location_enabled",
            deprecated: true,
            availableInWebhook: ["shop/update", "app/uninstalled"],
          },
        },
      },
      {
        key: ShopifyShopMyshopifyDomainKey,
        name: "myshopify Domain",
        fieldType: FieldType.String,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "myshopify_domain",
            graphQLFieldKey: "myshopifyDomain",
            availableInWebhook: ["shop/update", "app/uninstalled"],
          },
        },
      },
      {
        name: "Name",
        fieldType: FieldType.String,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "name",
            graphQLFieldKey: "name",
            availableInWebhook: ["shop/update", "app/uninstalled"],
          },
        },
      },
      {
        name: "Password Enabled",
        fieldType: FieldType.Boolean,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "password_enabled",
            deprecated: true,
            availableInWebhook: ["shop/update", "app/uninstalled"],
          },
        },
      },
      {
        name: "Phone",
        fieldType: FieldType.String,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "phone",
            graphQLFieldKey: "phone",
            skipGraphQLSelection: true,
            availableInWebhook: ["shop/update", "app/uninstalled"],
          },
        },
      },
      {
        name: "Plan Display Name",
        fieldType: FieldType.String,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "plan_display_name",
            graphQLFieldKey: "planDisplayName",
            skipGraphQLSelection: true,
            availableInWebhook: ["shop/update", "app/uninstalled"],
          },
        },
      },
      {
        name: "Plan Name",
        fieldType: FieldType.String,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "plan_name",
            deprecated: true,
            availableInWebhook: ["shop/update", "app/uninstalled"],
          },
        },
      },
      {
        name: "Pre Launch Enabled",
        fieldType: FieldType.Boolean,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "pre_launch_enabled",
            deprecated: true,
            availableInWebhook: ["shop/update", "app/uninstalled"],
          },
        },
      },
      {
        name: "Primary Locale",
        fieldType: FieldType.String,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "primary_locale",
            deprecated: true,
            availableInWebhook: ["shop/update", "app/uninstalled"],
          },
        },
      },
      {
        name: "Primary Location",
        fieldType: FieldType.BelongsTo,
        key: ShopifyShopToPrimaryLocationKey,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "primary_location_id",
            deprecated: true,
            availableInWebhook: ["shop/update", "app/uninstalled"],
          },
        },
        configuration: {
          relatedModelKey: ShopifyLocationKey,
        },
      },
      {
        name: "Province",
        fieldType: FieldType.String,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "province",
            graphQLFieldKey: "province",
            skipGraphQLSelection: true,
            availableInWebhook: ["shop/update", "app/uninstalled"],
          },
        },
      },
      {
        name: "Province Code",
        fieldType: FieldType.String,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "province_code",
            graphQLFieldKey: "provinceCode",
            skipGraphQLSelection: true,
            availableInWebhook: ["shop/update", "app/uninstalled"],
          },
        },
      },
      {
        name: "Requires Extra Payments Agreement",
        fieldType: FieldType.Boolean,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "requires_extra_payments_agreement",
            deprecated: true,
            availableInWebhook: ["shop/update", "app/uninstalled"],
          },
        },
      },
      {
        name: "Setup Required",
        fieldType: FieldType.Boolean,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "setup_required",
            graphQLFieldKey: "setupRequired",
            availableInWebhook: ["shop/update", "app/uninstalled"],
          },
        },
      },
      {
        name: "Shop Owner",
        fieldType: FieldType.String,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "shop_owner",
            graphQLFieldKey: "shopOwnerName",
            availableInWebhook: ["shop/update", "app/uninstalled"],
          },
        },
      },
      {
        name: "Shopify Created At",
        fieldType: FieldType.DateTime,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "created_at",
            graphQLFieldKey: "createdAt",
            availableInWebhook: ["shop/update", "app/uninstalled"],
          },
        },
      },
      {
        name: "Shopify Updated At",
        fieldType: FieldType.DateTime,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "updated_at",
            graphQLFieldKey: "updatedAt",
            availableInWebhook: ["shop/update", "app/uninstalled"],
          },
        },
      },
      {
        name: "Source",
        fieldType: FieldType.String,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "source",
            deprecated: true,
            availableInWebhook: ["shop/update", "app/uninstalled"],
          },
        },
      },
      {
        name: "Tax Shipping",
        fieldType: FieldType.Boolean,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "tax_shipping",
            graphQLFieldKey: "taxShipping",
            availableInWebhook: ["shop/update", "app/uninstalled"],
          },
        },
      },
      {
        name: "Taxes Included",
        fieldType: FieldType.Boolean,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "taxes_included",
            graphQLFieldKey: "taxesIncluded",
            availableInWebhook: ["shop/update", "app/uninstalled"],
          },
        },
      },
      {
        name: "Timezone",
        fieldType: FieldType.String,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "timezone",
            deprecated: true,
            availableInWebhook: ["shop/update", "app/uninstalled"],
          },
        },
      },
      {
        name: "Weight Unit",
        fieldType: FieldType.Enum,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "weight_unit",
            graphQLFieldKey: "weightUnit",
            isShopifyEnum: true,
            availableInWebhook: ["shop/update", "app/uninstalled"],
          },
        },
        configuration: {
          allowOther: true,
          allowMultiple: false,
          options: [{ name: "GRAMS" }, { name: "KILOGRAMS" }, { name: "OUNCES" }, { name: "POUNDS" }],
        },
      },
      {
        name: "ZIP Code",
        fieldType: FieldType.String,
        contributorConfiguration: {
          [ShopifyDominion.id]: { shopifyFieldKey: "zip", availableInWebhook: ["shop/update", "app/uninstalled"] },
        },
      },
      {
        name: "Billing Address",
        fieldType: FieldType.JSON,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "__gadget_graphql_billing_address",
            graphQLFieldKey: "billingAddress",
            graphQLOnlyField: true,
            graphQLSelection: `
            id
            address1
            address2
            city
            company
            coordinatesValidated
            country
            countryCodeV2
            formatted
            formattedArea
            latitude
            longitude
            phone
            province
            provinceCode
            zip
            `,
          },
        },
      },
      {
        name: "Alerts",
        fieldType: FieldType.JSON,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "__gadget_graphql_alerts",
            graphQLFieldKey: "alerts",
            graphQLOnlyField: true,
            graphQLSelection: `
            action {
              title
              url
            }
            description
            `,
          },
        },
      },
      {
        name: "Countries In Shipping Zones",
        fieldType: FieldType.JSON,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "__gadget_graphql_countries_in_shipping_zones",
            graphQLFieldKey: "countriesInShippingZones",
            graphQLOnlyField: true,
            graphQLSelection: `
            countryCodes
            includeRestOfWorld
            `,
          },
        },
      },
      {
        name: "Currency Formats",
        fieldType: FieldType.JSON,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "__gadget_graphql_currency_formats",
            graphQLFieldKey: "currencyFormats",
            graphQLOnlyField: true,
            graphQLSelection: `
            moneyFormat
            moneyInEmailsFormat
            moneyWithCurrencyFormat
            moneyWithCurrencyInEmailsFormat
            `,
          },
        },
      },
      {
        name: "Customer Accounts",
        fieldType: FieldType.Enum,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "__gadget_graphql_customer_accounts",
            graphQLFieldKey: "customerAccounts",
            graphQLOnlyField: true,
          },
        },
        configuration: {
          allowOther: true,
          allowMultiple: false,
          options: [{ name: "DISABLED" }, { name: "OPTIONAL" }, { name: "REQUIRED" }],
        },
      },
      {
        name: "Description",
        fieldType: FieldType.String,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "__gadget_graphql_description",
            graphQLFieldKey: "description",
            graphQLOnlyField: true,
          },
        },
      },
      {
        name: "Order Number Format Prefix",
        fieldType: FieldType.String,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "__gadget_graphql_order_number_format_prefix",
            graphQLFieldKey: "orderNumberFormatPrefix",
            graphQLOnlyField: true,
          },
        },
      },
      {
        name: "Order Number Format Suffix",
        fieldType: FieldType.String,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "__gadget_graphql_order_number_format_suffix",
            graphQLFieldKey: "orderNumberFormatSuffix",
            graphQLOnlyField: true,
          },
        },
      },
      {
        name: "Resource Limits",
        fieldType: FieldType.JSON,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "__gadget_graphql_resource_limits",
            graphQLFieldKey: "resourceLimits",
            graphQLOnlyField: true,
            graphQLSelection: `
            locationLimit
            maxProductOptions
            maxProductVariants
            redirectLimitReached
            `,
          },
        },
      },
      {
        name: "Rich Text Editor Url",
        fieldType: FieldType.URL,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "__gadget_graphql_rich_text_editor_url",
            graphQLFieldKey: "richTextEditorUrl",
            graphQLOnlyField: true,
          },
        },
        // this is a backwards compatibility alias for the field that was incorrectly named
        alias: ["Rich Text Edior Url"],
      },
      {
        name: "Ships To Countries",
        fieldType: FieldType.Enum,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "__gadget_graphql_ships_to_countries",
            graphQLFieldKey: "shipsToCountries",
            graphQLOnlyField: true,
          },
        },
        configuration: {
          allowOther: true,
          allowMultiple: true,
          options: shopifyCountryCodeEnumOptions,
        },
      },
      {
        name: "Timezone Abbreviation",
        fieldType: FieldType.String,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "__gadget_graphql_timezone_abbreviation",
            graphQLFieldKey: "timezoneAbbreviation",
            graphQLOnlyField: true,
          },
        },
      },
      {
        name: "Timezone Offset",
        fieldType: FieldType.String,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "__gadget_graphql_timezone_offset",
            graphQLFieldKey: "timezoneOffset",
            graphQLOnlyField: true,
          },
        },
        // this is a backwards compatibility alias for the field that was incorrectly named
        alias: ["Taxes Offset"],
      },
      {
        name: "Timezone Offset Minutes",
        fieldType: FieldType.Number,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "__gadget_graphql_timezone_offset_minutes",
            graphQLFieldKey: "timezoneOffsetMinutes",
            graphQLOnlyField: true,
          },
        },
      },
      {
        name: "Unit System",
        fieldType: FieldType.Enum,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "__gadget_graphql_unit_system",
            graphQLFieldKey: "unitSystem",
            graphQLOnlyField: true,
          },
        },
        configuration: {
          allowOther: true,
          allowMultiple: false,
          options: [{ name: "IMPERIAL_SYSTEM" }, { name: "METRIC_SYSTEM" }],
        },
      },
      {
        name: "Url",
        fieldType: FieldType.URL,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "__gadget_graphql_url",
            graphQLFieldKey: "url",
            graphQLOnlyField: true,
          },
        },
      },
    ],
    syncConfig: {
      type: "custom",
      resource: "shopQuery",
    },
  },
  "2025-07": {
    fields: [
      {
        name: "Plan",
        fieldType: FieldType.JSON,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "__gadget_graphql_shop_plan",
            graphQLFieldKey: "plan",
            graphQLOnlyField: true,
            graphQLSelection: `
            displayName
            partnerDevelopment
            shopifyPlus
            publicDisplayName
            `,
          },
        },
      },
      {
        name: "Plan Display Name",
        fieldType: FieldType.String,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "plan_display_name",
            graphQLFieldKey: "planDisplayName",
            skipGraphQLSelection: true,
            availableInWebhook: ["shop/update", "app/uninstalled"],
            deprecated: true,
          },
        },
      },
      {
        name: "Plan Public Display Name",
        fieldType: FieldType.String,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            graphQLFieldKey: "planPublicDisplayName",
            skipGraphQLSelection: true,
          },
        },
      },
    ],
  },
  "2026-01": {
    fields: [
      {
        name: "Billing Address",
        fieldType: FieldType.JSON,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "__gadget_graphql_billing_address",
            graphQLFieldKey: "billingAddress",
            graphQLOnlyField: true,
            graphQLSelection: `
            id
            address1
            address2
            city
            company
            coordinatesValidated
            country
            countryCodeV2
            formatted
            formattedArea
            latitude
            longitude
            phone
            province
            provinceCode
            zip
            `,
            deprecated: true,
          },
        },
      },
      {
        name: "Shop Address",
        fieldType: FieldType.JSON,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            graphQLFieldKey: "shopAddress",
            graphQLOnlyField: true,
            graphQLSelection: `
            id
            address1
            address2
            city
            company
            coordinatesValidated
            country
            countryCodeV2
            formatted
            formattedArea
            latitude
            longitude
            phone
            province
            provinceCode
            zip
            `,
            deprecated: true,
          },
        },
      },
      {
        name: "Return Reason Definitions",
        fieldType: FieldType.HasMany,
        key: ShopifyShopToReturnReasonDefinitionsKey,
        configuration: {
          relatedModelKey: ShopifyReturnReasonDefinitionKey,
          inverseFieldKey: ShopifyReturnReasonDefinitionToShopKey,
        },
      },
    ],
  },
  "2026-04": {
    fields: [
      {
        key: ShopifyShopRefreshTokenKey,
        name: "Refresh Token",
        fieldType: FieldType.EncryptedString,
        apiExposedOverride: false,
        dominionID: GadgetSystemDominionId,
        contributorConfiguration: {
          [GadgetSystemDominionId]: {
            isWritableInternally: true,
            storeInColumn: false,
          },
        },
      },
      {
        key: ShopifyShopAccessTokenExpiresAtKey,
        name: "Access Token Expires At",
        fieldType: FieldType.DateTime,
        apiExposedOverride: false,
        dominionID: GadgetSystemDominionId,
        contributorConfiguration: {
          [GadgetSystemDominionId]: {
            isWritableInternally: true,
            storeInColumn: false,
          },
        },
      },
      {
        key: ShopifyShopRefreshTokenExpiresAtKey,
        name: "Refresh Token Expires At",
        fieldType: FieldType.DateTime,
        apiExposedOverride: false,
        dominionID: GadgetSystemDominionId,
        contributorConfiguration: {
          [GadgetSystemDominionId]: {
            isWritableInternally: true,
            storeInColumn: false,
          },
        },
      },
    ],
  },
  "2026-07": {
    fields: [
      {
        name: "Collection Products",
        fieldType: FieldType.HasMany,
        key: ShopifyShopToCollectionProductsKey,
        configuration: {
          relatedModelKey: ShopifyCollectionProductKey,
          inverseFieldKey: ShopifyCollectionProductToShopKey,
        },
      },
    ],
  },
  "2026-10": {
    fields: [
      {
        name: "Requested Order Edits",
        fieldType: FieldType.HasMany,
        key: ShopifyShopToRequestedOrderEditsKey,
        configuration: {
          relatedModelKey: ShopifyRequestedOrderEditKey,
          inverseFieldKey: ShopifyRequestedOrderEditToShopKey,
        },
      },
      {
        name: "Requested Order Edit Line Items",
        fieldType: FieldType.HasMany,
        key: ShopifyShopToRequestedOrderEditLineItemsKey,
        configuration: {
          relatedModelKey: ShopifyRequestedOrderEditLineItemKey,
          inverseFieldKey: ShopifyRequestedOrderEditLineItemToShopKey,
        },
      },
      {
        name: "Return Policy Profiles",
        fieldType: FieldType.HasMany,
        key: ShopifyShopToReturnPolicyProfilesKey,
        configuration: {
          relatedModelKey: ShopifyReturnPolicyProfileKey,
          inverseFieldKey: ShopifyReturnPolicyProfileToShopKey,
        },
      },
    ],
  },
};

export const ShopifyShop = ({
  apiVersion,
  frameworkVersionConstraint,
}: {
  apiVersion: ShopifyApiVersion;
  frameworkVersionConstraint: string;
}) => buildConnectionSpec(specs, apiVersion, frameworkVersionConstraint);
